<template>
    <Navbar/>
    <main class="py-3">
        <div class="container">
            <div class="d-flex justify-content-center flex-wrap">
                <div class="col-12">
                    <h2>
                        <router-link to="/dashboard" class="text-first router-link" v-if="this.$route.name !== 'DashboardIndex'">
                            <i class="fa-solid fa-chevron-left"></i>
                            {{ $t('Dashboard.back') }}
                        </router-link>
                    </h2>
                </div>
                <div class="col-12 text-center my-4">
                    <h1>
                        {{ $t(`Dashboard.${this.$route.name}.RouteName`) }}
                    </h1>
                </div>
                <div class="col-12">
                    <router-view></router-view>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import Navbar from '../../components/Dashboard/Navbar.vue'
export default {
    name: 'DashboardView',
    components: {
        Navbar
    }
}
</script>